import { formatSeverityLower } from '../../utils/severity';
import { SchwachstelleList } from '../../types';
import { AuditChartDatum } from './auditDetailTypes';

export const severityOrder = ['kritisch', 'hoch', 'mittel', 'niedrig', 'info'];

export const getKritColorMap = (isDark: boolean): Record<string, string> => ({
  kritisch: '#ef5350',
  hoch: '#ffa726',
  mittel: '#42a5f5',
  niedrig: '#3dd47e',
  info: isDark ? '#667788' : '#8899aa',
  unbekannt: isDark ? '#556677' : '#9aa5b0',
});

const getKritCounts = (schwachstellen: SchwachstelleList[]) => {
  const counts: Record<string, number> = {};
  schwachstellen.forEach((s) => {
    const formatted = formatSeverityLower(s.kritikalitaet);
    const key = formatted || 'unbekannt';
    counts[key] = (counts[key] || 0) + 1;
  });
  return counts;
};

export const buildKritData = (
  schwachstellen: SchwachstelleList[],
  isDark: boolean,
): AuditChartDatum[] => {
  const counts = getKritCounts(schwachstellen);
  const colorMap = getKritColorMap(isDark);

  return [...severityOrder, 'unbekannt']
    .map((name) => ({
      name,
      value: counts[name] || 0,
      color: colorMap[name],
    }))
    .filter((entry) => entry.value > 0);
};

export const buildReviewData = (schwachstellen: SchwachstelleList[]): AuditChartDatum[] => [
  {
    name: 'Geprüft',
    value: schwachstellen.filter((s) => s.status?.name === 'Geprueft').length,
    color: '#4caf50',
  },
  {
    name: 'Review erbeten',
    value: schwachstellen.filter((s) => s.status?.name === 'Review erbeten').length,
    color: '#ff9800',
  },
  {
    name: 'Abgelehnt',
    value: schwachstellen.filter((s) => s.status?.name === 'Abgelehnt').length,
    color: '#b71c1c',
  },
  {
    name: 'Entwurf',
    value: schwachstellen.filter((s) => !s.status || s.status.name === 'Entwurf').length,
    color: '#2196f3',
  },
].filter((entry) => entry.value > 0);
